<template>
		<multiselect v-model="inputValue"
								 :tag-placeholder="$t('vforms.vue_multiselect_add_this_as_new_tag')"
								 :placeholder="placeholder"
								 :options="optionItems"
								 :multiple="multiple"
								 :taggable="false"
								 :disabled="disabled || readonly"
								 :track-by="vueSelectTrackBy"
								 :label="vueSelectLabel"
								 :class="inputClassListLive"
								 :max="max"
								 :selectedLabel="$t('vforms.vue_multiselect_select_label')"
								 :selectLabel="$t('vforms.vue_multiselect_select_label')"
								 :deselectLabel="$t('vforms.vue_multiselect_deselect_label')"
								 :close-on-select="false"
								 :clear-on-select="false"
								 :preserve-search="true"
								 :preselect-first="true"
								 @search-change="searchChange"
								 @tag="addTag"
								 @input="onInputHandler">
			<template slot="vueSelectLabel" slot-scope="{ option }">{{ option.name }}</template>
			<template slot="selection" slot-scope="{ values, search }">
				<span class="multiselect__single" v-if="values.length >= minSelectionShowCount">
					{{$t('vforms.vue_multiselect_selection', { number: values.length})}}
				</span>
			</template>
			<span slot="noOptions">{{$t('vforms.vue_multiselect_no_options')}}</span>
			<span slot="noResult">{{$t('vforms.vue_multiselect_no_result')}}</span>
		</multiselect>
</template>

<script>
import {baseInput} from './../mixins/index.js';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: 'MultiSelect',
  components: {
    Multiselect
  },
  props: {
    asyncFind: {type: Function, requierd: false},
    options: {type: Array, required: false, default: () => []},
    multiple: {type: Boolean, required: false, default: true},
		max: {type: Number, required: false, default: 99},
		minSelectionShowCount: {type: Number, required: false, default: 9},
    taggable: {type: Boolean, required: false, default: false},
    vueSelectLabel: {type: String, required: false, default: 'name'},
    vueSelectTrackBy: {type: String, required: false, default: 'id'},
  },
  mixins: [baseInput],
  data() {
    return {
      inputValue: null,
      hasFocus: false,
      isLoading: false,
      asyncOptions: []
    }
  },
  computed: {
    optionItems() {
      return this.asyncFind ? this.asyncOptions : this.options;
    },
		inputClassListLive() {
			return this.inputClassList;
		},
  },
  methods: {
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },
    async searchChange(searchQuery, id) {
      this.$emit('search-change', searchQuery, id);

      if ( this.asyncFind ) {
        const asyncFindResult = this.asyncFind(searchQuery);

        if ( Array.isArray(asyncFindResult) ) {
          this.asyncOptions = asyncFindResult;
        }

        if ( typeof asyncFindResult.then === 'function' ) {
          this.isLoading = true;
          const response = await asyncFindResult;

          this.asyncOptions =
              Array.isArray(response.data) ?
                  response.data :
                  Array.isArray(response) ?
                      response :
                      [];

          this.isLoading = false;
        }
      }
    }
  }
};
</script>
